import React, { useEffect, useState, useRef } from "react";
import edit from "../../pics/UsercarEdit.svg";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import API from "../../api/api";
import axios from "axios";
// import { useStripe } from "@stripe/react-stripe-js";
import PayPalButtonGroup from "../../components/Dashcomponents/PayPalButtonGroup";
import PayPalPaymentSuccessfulModal from "../../components/Dashcomponents/PayPalPaymentSuccessfulModal";
import PayPalPaymentSuccessfulModalGeneralTip from "../../components/Dashcomponents/PayPalPaymentSuccessfulModalGeneralTip";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../components/custom-ui/ToolTIp";

import question from "../../pics/Question.png";
import apisecured from "../../api/apisecured";
import { setToast } from "../../State/toastSlice";
import RyftPayButton from "../../components/Dashcomponents/RyftPayButton";

function GeneralTipCard({ text = "General Tip" }) {
  const userlogin = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const creatorUser = useSelector((state) => state.userProfile);
  const navigate = useNavigate();
  const otherProfile = useSelector((state) => state.userProfile);
  const { username } = useParams();
  const isLoggedIn = userlogin.isAuthenticated;
  const [uid, setUid] = useState(null);
  const [showPayPalSuccessModal, setShowPayPalSuccessModal] = useState(false);
  const fetchUserDetails = async () => {
    try {
      const response = await axios.get(
        `${API}account/get_user_data_by_username?username=${username}`,
      );
      setUid(response.data.uid);
    } catch (error) {
      console.error("Failed to fetch user details:", error);
      dispatch(
        setToast({
          message: "Failed to load user data.",
          type: "error",
        }),
      );
    }
  };

  useEffect(() => {
    fetchUserDetails();
  }, [username]);
  const [goals, setGoals] = useState([]);
  const [selectedGoalUUID, setSelectedGoalUUID] = useState("");
  const [amount, setAmount] = useState("");
  const [name, setName] = useState(userlogin.sponsaUserName || "");
  const [message, setMessage] = useState("");
  const amountRef = useRef("");
  const [btnLoading, setBtnLoading] = useState(false);
  // const stripe = useStripe();
  const [showGuestEmailField, setShowGuestEmailField] = useState(false);
  const [guestEmail, setGuestEmail] = useState("");
  useEffect(() => {
    const fetchGoals = async () => {
      if (!username) return [];
      try {
        const response = await axios.get(
          `${API}goals/get_all_goals?username=${username}`,
        );
        const activeGoals = response.data.filter(
          (goal) => goal.status === "ACTIVE",
        );
        setGoals(activeGoals);
      } catch (error) {
        console.error("Error fetching goals in quick tip card:", error);
        dispatch(
          setToast({
            message: "Failed to fetch goals",
            type: "error",
          }),
        );
      }
    };

    fetchGoals();
  }, [username]); // This effect runs only when `uid` changes

  const handleFundClick = async () => {
    if (!userlogin.isAuthenticated) {
      navigate(`/account`);
      return;
    }
    if (!amount) {
      dispatch(
        setToast({
          message: "Amount is required",
          type: "error",
        }),
      );
      return;
    }
    // if (!message) {
    //   toast.error("Message is required");
    //   return;
    // }
    setBtnLoading(true);
    try {
      const payload = {
        // UID: userlogin.uid,
        ReceipentUID: uid,
        amount: amount,
        name: name,
        message: message,
      };

      const response = await apisecured.post(
        `${API}stripe/create-checkout-session`,
        payload,
      );
      //       const response = await axios.post(
      //   `https://localhost:44318/v1/stripe/create-checkout-session`,
      //   payload
      // );
      if (response.status === 200) {
        const session = response.data;
        window.location.href = session.sessionId;
      } else {
        dispatch(
          setToast({
            message: `Error: ${response.status} - ${response.statusText}`,
            type: "error",
          }),
        );
      }
    } catch (error) {
      console.error("Error details:", error); // Log the error details for debugging
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorCode === 4027
      ) {
        const formattedMessage = error.response.data.errorMessage
          .toLowerCase()
          .replace(/_/g, " ")
          .replace(/^\w/, (c) => c.toUpperCase());
        dispatch(
          setToast({
            message: `${formattedMessage}`,
            type: "error",
          }),
        );
      } else {
        dispatch(
          setToast({
            message: `Error: ${
              error.response &&
              error.response.data &&
              error.response.data.errorMessage
                ? error.response.data.errorMessage
                : "Network error"
            }`,
            type: "error",
          }),
        );
      }
    } finally {
      setBtnLoading(false);
    }
  };
  const handlePayPalPaymentSuccess = () => {
    setShowPayPalSuccessModal(true); // Open the modal
  };
  const handleClosePayPalModal = () => {
    setShowPayPalSuccessModal(false);
    window.location.reload();
  };
  const showAlert = () => {
    dispatch(
      setToast({
        message: "This creator has not set up a payment method.",
        type: "error",
      }),
    );
  };
  return (
    <>
      <PayPalPaymentSuccessfulModalGeneralTip
        open={showPayPalSuccessModal}
        onClose={() => setShowPayPalSuccessModal(false)}
        onModalClose={handleClosePayPalModal}
      />
      <div className=" px-2  py-2">
        <div className=" flex items-center justify-between w-full  ">
          <p className=" text-[16px] font-bold leading-[20px] tracking-[-0.02em] text-left text-white   ">
            {text}
          </p>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <img
                  src={question}
                  alt=""
                  width={24}
                  height={24}
                  className="w-[24px] h-[24px]  "
                />
              </TooltipTrigger>
              <TooltipContent>
                <p className=" font-normal text-[17px] leading-[100%] tracking-[0%] ">
                  Send a tip here if you want to tip without it counting towards
                  a specific goal!
                </p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        {/* <select
        className="select DataSelectCustom !leading-[12px] bg-transparent text-white w-full max-w-[unset] px-6 rounded-full border-[1px] border-[#E6E6E633] mt-4 !bg-[calc(100%_-_15px)_calc(1px_+_50%),_calc(100%_-_16.1px)_calc(1px_+_50%)] [&>option]:bg-[#35334D99]"
        value={selectedGoalUUID}
        onChange={(e) => setSelectedGoalUUID(e.target.value)}
      >
        <option value="">Click to select a goal</option>
        {goals.length > 0 ? (
          goals.map((goal) => (
            <option key={goal.goaluuid} value={goal.goaluuid}>
              {goal.title}
            </option>
          ))
        ) : (
          <option disabled>This user has no active goals</option>
        )}
      </select> */}
        <div className=" flex items-center justify-between gap-4 mt-4 ">
          <div className=" bg-[#FFFFFF26] rounded-full px-9 py-3  w-fit  text-white ">
            {otherProfile.currency}
          </div>
          <input
            type="text"
            value={amount}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value)) {
                setAmount(value);
                amountRef.current = value;
              }
            }}
            required
            placeholder="0"
            className="  bg-transparent  CustomInputPLaceholder placeholder:CustomInputPLaceholder   ![text-transform:unset]  text-white w-full max-w-[unset] py-4 px-4 rounded-full   border-[1px] border-[#E6E6E633] placeholder:text-white"
          />
        </div>
        <input
          type="text"
          name=""
          id=""
          placeholder="Your Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className=" bg-transparent mt-4 CustomInputPLaceholder placeholder:CustomInputPLaceholder   ![text-transform:unset]  text-white w-full max-w-[unset] py-4 px-4 rounded-full   border-[1px] border-[#E6E6E633]  placeholder:text-white  "
        />
        <textarea
          name=""
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          className="bg-transparent mt-4 CustomInputPLaceholder placeholder:CustomInputPLaceholder  ![text-transform:unset]  text-white w-full max-w-[unset] py-4 px-4 rounded-[8px]   border-[1px] border-[#E6E6E633] placeholder:text-white   h-28 min-h-20 max-h-40 "
          id=""
          cols="20"
          rows="8"
          placeholder="Your Message"
        ></textarea>
        {/* {creatorUser.stripeConnected &&
          creatorUser.userName !== userlogin.sponsaUserName && (
            <button
              type="submit"
              disabled={btnLoading}
              onClick={handleFundClick}
              className=" text-[13px] font-medium leading-[15px] tracking-[-0.02em] text-center  CustomButtonAnim text-[#030021] bg-[#00FF8F] mt-4  rounded-[25px]  py-[0.8rem] w-full    "
            >
              {btnLoading ? (
                <>
                  Tip
                  <div className="loader0"></div>
                </>
              ) : (
                "Tip"
              )}
            </button>
          )} */}
        {creatorUser.paypalConnected &&
          creatorUser.userName !== userlogin.sponsaUserName && (
            <PayPalButtonGroup
              currency={creatorUser.currency}
              userlogin={userlogin}
              amountRef={amountRef}
              name={name}
              message={message}
              ReceipentUID={uid}
              isGeneralDonation={true}
              onSuccess={handlePayPalPaymentSuccess}
            />
          )}
        {creatorUser.ryftConnected &&
          creatorUser.userName !== userlogin.sponsaUserName && (
            <>
              {creatorUser.paypalConnected && (
                <p
                  className="text-white text-center mt-2 mb-0 text-[21px] font-normal leading-[26px]"
                  style={{ fontWeight: 600 }}
                >
                  or
                </p>
              )}
              {!isLoggedIn && showGuestEmailField && (
                <div className="flex flex-col gap-1.5">
                  <span className="text-xs font-semibold text-[var(--text-tertiary)] uppercase tracking-wide">
                    Email Address
                  </span>

                  <input
                    type="email"
                    value={guestEmail}
                    onChange={(e) => setGuestEmail(e.target.value)}
                    placeholder="you@example.com"
                    className="w-full bg-[var(--bg-input)] border border-[var(--border)] rounded-lg py-2.5 px-3 text-sm text-[var(--text-primary)] outline-none transition-all focus:bg-[var(--bg-input-focus)] focus:border-[var(--primary)] focus:shadow-[0_0_0_3px_var(--primary-glow)]"
                  />

                  <p className="text-[11px] text-[var(--text-tertiary)] leading-relaxed">
                    Email is for receipt purposes only.
                  </p>
                </div>
              )}
              <RyftPayButton
                currency={creatorUser.currency}
                userlogin={userlogin}
                amountRef={amountRef}
                name={name}
                message={message}
                ReceipentUID={uid}
                isGeneralDonation={true}
                guestEmail={guestEmail}
                onRequireGuestEmail={() => setShowGuestEmailField(true)}
                onSuccess={handlePayPalPaymentSuccess}
              />
            </>
          )}
        {userlogin.sponsaUserName &&
          !creatorUser.ryftConnected &&
          !creatorUser.paypalConnected &&
          creatorUser.userName !== userlogin.sponsaUserName && (
            <button
              type="submit"
              disabled={btnLoading}
              onClick={showAlert}
              className=" text-[13px] font-medium leading-[15px] tracking-[-0.02em] text-center  CustomButtonAnim text-[#030021] bg-[#00FF8F] mt-4  rounded-[25px]  py-[0.8rem] w-full    "
            >
              {btnLoading ? (
                <>
                  Tip
                  <div className="loader0"></div>
                </>
              ) : (
                "Tip"
              )}
            </button>
          )}
      </div>
    </>
  );
}

export default GeneralTipCard;
